<template>
  <div>
    <el-row :gutter="4" class="mr-b4">
      <el-col :span="12">
        <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
      </el-col>
      <el-col :span="12">
        <w-collection-judgement-rule-popup-button :obj-info="objInfo"></w-collection-judgement-rule-popup-button>
      </el-col>
    </el-row>
    <el-row :gutter="4" class="mr-b25">
      <el-col :span="12">
        <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth"></w-event-alarm-rule-popup-button>
      </el-col>
      <el-col v-if="objInfo.obj.objtypeId === 'VHO' || objInfo.obj.objtypeId === 'VDS' || objInfo.obj.objtypeId === 'VVM'" :span="12">
        <w-simulation-predict-popup-button :obj="objInfo" />
      </el-col>
    </el-row>
    <el-row v-if="objInfo.obj.objtypeId === 'VVM'" class="mr-b25">
      <div class="title-h4 title-bar">VM 제어</div>
      <el-row :gutter="4" style="margin-bottom:4px;">
        <el-col v-if="vmFlag && (vmwareFlag || kvmFlag || xenFlag || hypervFlag || rhevFlag)" :span="12">
          <el-button style="width:100%;" size="small" type="primary" @click="onClickRemoteControl()">원격제어</el-button>
        </el-col>
        <el-col v-if="vmFlag && (vmwareFlag || kvmFlag || xenFlag || hypervFlag || rhevFlag)" :span="12">
          <el-button style="width:100%;" size="small" type="primary" @click="onClickVmControl('START')">시작</el-button>
        </el-col>
        <el-col v-if="vmFlag && (vmwareFlag || kvmFlag || xenFlag || hypervFlag || rhevFlag)" :span="12">
          <el-button style="width:100%;" size="small" type="primary" @click="onClickVmControl('RESTART')">재시작</el-button>
        </el-col>
        <el-col v-if="vmFlag && (vmwareFlag || kvmFlag || xenFlag || hypervFlag || rhevFlag)" :span="12">
          <el-button style="width:100%;" size="small" type="primary" @click="onClickVmControl('END')">종료</el-button>
        </el-col>
        <el-col v-if="vmFlag && (vmwareFlag || kvmFlag || xenFlag || hypervFlag || rhevFlag)" :span="12">
          <el-button style="width:100%;" size="small" type="primary" @click="onClickVmControl('SUSPEND')">일시정지</el-button>
        </el-col>
        <el-col v-if="vmFlag && (vmwareFlag || xenFlag || hypervFlag)" :span="12">
          <w-virtual-snap-shot-popup :obj-info="objInfo" />
        </el-col>
        <el-col v-if="vmFlag && (vmwareFlag || xenFlag || hypervFlag) && userInfo.managerId == 'administrator'" :span="12">
          <w-virtual-migration-popup :obj-info="objInfo" />
        </el-col>
        <el-col v-if="templateFlag && (vmwareFlag || xenFlag) && userInfo.managerId == 'administrator'" :span="12">
          <el-button style="width:100%;" size="small" type="primary" @click="convertFromTemplate()">변환/복제</el-button>
          <w-virtual-template-convert-popup ref="virtualTemplateConvertPopupRef" :obj-info="objInfo"></w-virtual-template-convert-popup>
        </el-col>
        <el-col v-if="vmFlag && (vmwareFlag || xenFlag) && userInfo.managerId == 'administrator'" :span="12">
          <el-button style="width:100%;" size="small" type="primary" @click="convertFromVm()">변환/복제</el-button>
          <w-virtual-vm-convert-popup ref="virtualVmConvertPopupRef" :obj-info="objInfo"></w-virtual-vm-convert-popup>
        </el-col>
      </el-row>
    </el-row>
    <w-basic-sliding-button-group v-if="(objInfo.obj.objtypeId === 'VHO') || (objInfo.obj.objtypeId === 'VVM')" :obj-info="objInfo" />
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import msgUtil from '@/utils/message';
import { mapGetters } from 'vuex';
import { applicationLauncher } from '@/utils/applauncher';
import vmsApi from '@/api/virtual/performance/common';
import appApi from '@/api/common/app';
import HambugerPopupMixin from '@/mixins/performance/hambuger-popup';
import WBasicSlidingButtonGroup from './BasicSlidingButtonGroup';
import WCommonSettingChartTypePopupButton from './CommonSettingChartTypePopupButton';
import WCollectionJudgementRulePopupButton from './CollectionJudgementRulePopupButton';
import WEventAlarmRulePopupButton from './EventAlarmRulePopupButton';
import WVirtualSnapShotPopup from './VirtualSnapShotPopup';
import WVirtualConnectIsoPopup from './VirtualConnectIsoPopup';
import WVirtualMigrationPopup from './VirtualMigrationPopup';
import WVirtualVmConvertPopup from './VirtualVmConvertPopup';
import WVirtualTemplateConvertPopup from './VirtualTemplateConvertPopup';
import WSimulationPredictPopupButton from './button/common/SimulationPredictPopupButton';

export default {
  name: 'WVirtualSlidingButtonGroup',
  components: {
    WBasicSlidingButtonGroup,
    WCommonSettingChartTypePopupButton,
    WCollectionJudgementRulePopupButton,
    WEventAlarmRulePopupButton,
    WVirtualSnapShotPopup,
    WVirtualConnectIsoPopup,
    WVirtualMigrationPopup,
    WVirtualVmConvertPopup,
    WVirtualTemplateConvertPopup,
    WSimulationPredictPopupButton,
  },
  mixins: [HambugerPopupMixin],
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    controlTypeName() {
      if (this.controlType === 'START') {
        return '시작';
      } else if (this.controlType === 'RESTART') {
        return '재시작';
      } else if (this.controlType === 'END') {
        return '종료';
      }
      return '일시정지';
    },
    vmwareFlag() {
      return this.objInfo.hypervisorType === 'VMWARE';
    },
    hypervFlag() {
      return this.objInfo.hypervisorType === 'HYPERV';
    },
    xenFlag() {
      return this.objInfo.hypervisorType === 'XENSERVER';
    },
    kvmFlag() {
      return this.objInfo.hypervisorType === 'KVM';
    },
    rhevFlag() {
      return this.objInfo.hypervisorType === 'RHEV';
    },
    vmFlag() {
      return this.objInfo.vmTemplateFlag === '0';
    },
    templateFlag() {
      return this.objInfo.vmTemplateFlag === '1';
    },
    ...mapGetters(['userInfo']),
  },
  data() {
    return {
      controlType: '',
    };
  },
  methods: {
    // vm 제어
    onClickVmControl(controlType) {
      this.controlType = controlType;
      const params = {
        controlType,
        objId: this.objInfo.obj.objId,
      };
      this.$confirm(...msgUtil.getCustomConfirmData(`VM을 ${this.controlTypeName}하시겠습니까?`)).then(() => {
        // api
        vmsApi.executeVmContorl(params).then((res) => {
          if (res.data.success) {
            if (res.data.data === 'DOWN') {
              this.$message(msgUtil.getCustomResultMsgData('VM이 실행되어있지 않습니다.', false));
            } else if (res.data.data === 'ERROR') {
              this.$message(msgUtil.getResultMsgData(this.controlTypeName, 'VM', false));
            } else {
              this.$message(msgUtil.getResultMsgData(this.controlTypeName, 'VM', true));
            }
          } else {
            this.$message(msgUtil.getResultMsgData(this.controlTypeName, 'VM', false));
          }
        });
      }).catch(() => {});
    },
    // vm 원격제어
    onClickRemoteControl() {
      this.$confirm(...msgUtil.getCustomConfirmData('원격제어를 실행하시겠습니까?')).then(() => {
        vmsApi.getVmTypeAndIPAddress({ objId: this.objInfo.obj.objId }).then((response) => {
          if (response.data.success) {
            if (response.data.data.status === 'VM_DOWN') {
              this.$message(msgUtil.getCustomResultMsgData('VM이 실행되어 있지 않습니다.'));
            } else if (response.data.data.status === 'DATA_NULL') {
              this.$message(msgUtil.getCustomResultMsgData('원격제어를 하기위한 데이터가 부족합니다.'));
            } else {
              const ipaddress = response.data.data.ipaddress;
              const objtypeId = response.data.data.objtypeId;
              appApi.getAppExecuteInfo(this.objInfo.obj.objId).then((res) => {
                if (res.data.success && !isEmpty(res.data.data)) {
                  const obj = res.data.data;
                  obj.objtypeId = objtypeId;
                  if (obj.ipaddressApplytype === 'IPv4') {
                    obj.ipaddressIpv4 = ipaddress;
                  } else {
                    obj.ipaddressIpv6 = ipaddress;
                  }

                  applicationLauncher().directExecute(obj.useSSH ? 'SSH' : 'TELNET', obj, this);
                }
              });
            }
          } else {
            this.$message(msgUtil.getCustomResultMsgData('실행이 완료되지 못했습니다.'));
          }
        });
      }).catch(() => {});
    },
    convertFromVm() {
      this.$refs.virtualVmConvertPopupRef.open();
    },
    convertFromTemplate() {
      this.$refs.virtualTemplateConvertPopupRef.open();
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/VirtualSlidingButtonGroup.vue